// Recently opened model workspaces, kept per browser in localStorage.
const KEY = 'recentModels'
const MAX_ENTRIES = 5

export const getRecentModels = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(KEY))
        return Array.isArray(parsed) ? parsed : []
    } catch {
        return []
    }
}

// One entry per (model, merge rule) pair; reopening a pair moves it to the front.
export const recordRecentModel = (entry) => {
    try {
        const rest = getRecentModels().filter(e => !(e.modelId === entry.modelId && e.mergeRuleId === entry.mergeRuleId))
        localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, MAX_ENTRIES)))
    } catch {
        // private mode etc. — the history is a convenience, never an error
    }
}
